module.exports = __webpack_public_path__ + "static/img/vrroad_icon.4fa8d76a.png";